module.exports = __webpack_public_path__ + "img/PtownFlags_03.bf2dbd6e.png";